import { AI_THEME } from "pages/Rostering/UpdatedTimeSheet/TimeSheetDetailsSection/ai/aiTheme";

/** Re-export system AI tokens — Copilot must stay on Vertex360 blue. */
export { AI_THEME };

export const VERTEX360_COPILOT_THEME = {
  ...AI_THEME,

  /** Drawer shell */
  drawerBg: "bg-[#F8FAFE]",
  drawerBorder: "border-slate-200/80",
  panelSurface: "bg-white/90 backdrop-blur-sm border border-slate-200/70 shadow-sm",

  /** Header */
  headerBg: "bg-white/95 backdrop-blur-md border-b border-slate-200/80",
  heroGradient: "bg-gradient-to-br from-[#4B6CB7] via-[#3d5aa0] to-[#293F6A]",
  statusReady: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",

  /** User message */
  userCard: "bg-gradient-to-br from-[#4B6CB7] to-[#293F6A] text-white shadow-md shadow-[#4B6CB7]/20",

  /** Assistant answer card */
  answerCard:
    "bg-white border border-slate-200/90 rounded-2xl shadow-[0_4px_24px_-8px_rgba(41,63,106,0.12)]",
  answerCardHover: "hover:shadow-[0_8px_32px_-8px_rgba(41,63,106,0.16)]",
  answerCardError:
    "bg-red-50 border border-red-200/90 rounded-2xl shadow-sm text-red-800",

  /** Prompt chips */
  promptCard:
    "bg-white border border-slate-200/90 rounded-xl shadow-sm hover:border-[#C7D7F5] hover:bg-[#FAFCFF] hover:shadow-md",
  promptIcon: "bg-[#ECF0FD] text-[#4B6CB7] group-hover:bg-gradient-to-br group-hover:from-[#4B6CB7] group-hover:to-[#293F6A] group-hover:text-white",

  /** Composer */
  composerShell:
    "bg-white/95 backdrop-blur-md border border-slate-200/90 shadow-[0_-8px_32px_-12px_rgba(41,63,106,0.15)]",
  composerInput:
    "bg-[#F4F7FE] border border-slate-200/80 focus-within:border-[#4B6CB7] focus-within:bg-white focus-within:shadow-[0_8px_28px_-12px_rgba(41,63,106,0.35)]",

  /** Agent typing — animated icon only */
  agentStep: "bg-[#ECF0FD]/60 border border-blue-100/80 text-[#293F6A]",
};

export default VERTEX360_COPILOT_THEME;
